import { Emitter } from '@socket.io/component-emitter';

// Fail-safe emit: guard each listener so one throw doesn’t abort others or crash the app (e.g., onDataReceive).
// Stays same-tick to preserve ordering/semantics; switch to queueMicrotask if you need decoupling.

Emitter.prototype.emit = function(event, ...args) {
  const ctx = this;
  const list = (this.listeners ? this.listeners(event) : []).slice();

  list.forEach((fn: (...args: unknown[]) => unknown) => {
    try {
      fn.apply(ctx, args);
    } catch (err) {
      console.error(`[component-emitter:${String(event)}] listener error`, err);
      // rethrow async to surface
      setTimeout(() => {
        throw err;
      }, 0);
    }
  });
  return this;
};
